import React from "react";
import CircleIcon from "../../../../assets/icons/common/circleIcon.svg";
import ActiveIcon from "../../../../assets/icons/common/doneIcon.svg";
import ArrowDown from "../../../../assets/icons/common/arrowDown.svg";
const Tabs = ({ onTabChange, activeTab }) => {
  const handleTabClick = (tabName) => {
    onTabChange(tabName);
  };

  let labelTab;

  if(activeTab === 'subjectForm') {
    labelTab = 'Konu Testi'
  }
  if(activeTab === 'lessonForm') {
    labelTab = 'Ders Testi'
  }
  if(activeTab === 'randomForm') {
    labelTab = 'Rastgele Test'
  }

  return (
    <>
      {/* Desktop Tabs */}
      <div className="w-100 hidden lg:grid grid-cols-3 p-[16px] ">
        {/* Tab 1: Konu Testi */}
        <div
          className={`w-100 flex items-center justify-between px-[24px] py-[12px] border-b-[2px] ${
            activeTab === "subjectForm"
              ? "border-[#34BD5A] cursor-pointer"
              : "border-[#94A3B8] cursor-pointer"
          }`}
          onClick={() => handleTabClick("subjectForm")}
        >
          <h3
            className={`text-[14px] ${
              activeTab === "subjectForm" ? "text-[#34BD5A]" : "text-[#94A3B8]"
            }`}
          >
            Konu Testi
          </h3>
          {activeTab === "subjectForm" ? (
            <img src={ActiveIcon} alt="" />
          ) : (
            <img src={CircleIcon} alt="" />
          )}
        </div>

        {/* Tab 2: Ders Testi */}
        <div
          className={`w-100 flex items-center justify-between px-[24px] py-[12px] border-b-[2px] ${
            activeTab === "lessonForm"
              ? "border-[#34BD5A] cursor-pointer"
              : "border-[#94A3B8] cursor-pointer"
          }`}
          onClick={() => handleTabClick("lessonForm")}
        >
          <h3
            className={`text-[14px] ${
              activeTab === "lessonForm" ? "text-[#34BD5A]" : "text-[#94A3B8]"
            }`}
          >
            Ders Testi
          </h3>
          {activeTab === "lessonForm" ? (
            <img src={ActiveIcon} alt="" />
          ) : (
            <img src={CircleIcon} alt="" />
          )}
        </div>

        {/* Tab 3: Random Testi */}
        <div
          className={`w-100 flex items-center justify-between px-[24px] py-[12px] border-b-[2px] ${
            activeTab === "randomForm"
              ? "border-[#34BD5A] cursor-pointer"
              : "border-[#94A3B8] cursor-pointer"
          }`}
          onClick={() => handleTabClick("randomForm")}
        >
          <h3
            className={`text-[14px] ${
              activeTab === "randomForm" ? "text-[#34BD5A]" : "text-[#94A3B8]"
            }`}
          >
            Rastgele Test
          </h3>
          {activeTab === "randomForm" ? (
            <img src={ActiveIcon} alt="" />
          ) : (
            <img src={CircleIcon} alt="" />
          )}
        </div>
      </div>

      <div className="w-100 grid grid-cols-1  lg:hidden cursor-pointer">
        <div className="flex items-center justify-between p-[16px]">
          <h3 className="font-bold">{labelTab}</h3>
          <img src={ArrowDown} alt="" />
        </div>
        <div className="w-100 h-[2px] bg-[#34BD5A]"></div>
      </div>
    </>
  );
};

export default Tabs;
